export default "__VITE_ASSET__BXuqnmkZ__"